import Store from "@/lobby_common/store/index";
// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
export function formatTimeToStr(times, pattern) {
  if (!times?.getDate) {
    // 兼容 苹果的 new Date('yyyy-MM-dd') 的问题
    return times;
  }
  var d = new Date(times).Format("yyyy-MM-dd hh:mm:ss");
  if (pattern) {
    d = new Date(times).Format(pattern);
  }
  return d.toLocaleString();
}

// 时间戳处理 时区问题 timeStamp 时间 1211221  timeZone ，那个区域 -3 类似
export function getAnyZoneTime(timeStamp, pattern = "yyyy-MM-dd hh:mm:ss") {
  const timeStampTmp = getAnyZoneTimeStamp(timeStamp);
  return formatTimeToStr(new Date(timeStampTmp), pattern);
}

// 默认美东时间
export function formatTimeToString(times, pattern) {
  // 时间戳到秒
  if (!times) return times;
  return getAnyZoneTime(Number(times) * 1000, pattern);
}

export function formatTimeToDate(timeStamp) {
  // 秒时间戳转化为日期
  const timeStampTmp = getAnyZoneTimeStamp(timeStamp);
  const dateObj = new Date(timeStampTmp);
  const year = dateObj.getFullYear();
  const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
  const day = dateObj.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}
export function formatTimeToDate1(timeStamp) {
  // 秒时间戳转化为日期
  const dateObj = new Date(timeStamp);
  const year = dateObj.getFullYear();
  const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
  const day = dateObj.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}

// 时间戳处理 时区问题 返回时间不要年
export function getAnyZoneTime1(timeStamp) {
  const timeStampTmp = getAnyZoneTimeStamp(timeStamp);
  return formatTimeToStr(new Date(timeStampTmp), "MM-dd hh:mm:ss");
}

// 字符串转成时间戳  兼容 safari
export function formatTimeToStamp(str) {
  const time = str.replaceAll("-", "/");
  const Stamp = new Date(time).getTime();
  return Stamp;
}
// 当前时间，对应的美东时间戳
export function getAnyZoneTimeStamp(
  nowTime = Date.now(),
  timeZone = Store.getters?.getPacketConfig?.appConfig?.timeZone || null
) {
  // console.log('timeZone', timeZone)
  if (timeZone === undefined || timeZone === null) {
    timeZone = -4;
  }
  const timeStampTmp =
    nowTime +
    (new Date().getTimezoneOffset() + parseInt(timeZone) * 60) * 60 * 1000;
  return timeStampTmp;
}

// 时间戳（美东时间） =>  时间戳（应用时区 timeZone）
// 处理提交时间
export function getAppTimeStamp(timeStamp) {
  console.log(timeStamp, "timeStamp");
  // timeStamp10位
  let timeZone = Store.getters?.getPacketConfig?.appConfig?.timeZone || null;
  if (timeZone === undefined || timeZone === null) {
    timeZone = -4;
  }
  const nowTime = new Date();
  const offset = -nowTime.getTimezoneOffset() / 60;
  console.log(offset, "offset");
  const timeStampTmp =
    timeStamp + (offset - parseInt(timeZone)) * 60 * 60 * 1000;

  return Math.floor(timeStampTmp / 1000);
}
// 根据返回时间戳，算出倒计时时间
export function getAnyZoneTodayDownTimeStamp(
  nowTime = Date.now(),
  timeZone = Store.getters?.getPacketConfig?.appConfig?.timeZone || null
) {
  if (timeZone === undefined || timeZone === null) {
    timeZone = -4;
  }
  const timeStampTmp =
    nowTime +
    (new Date().getTimezoneOffset() + parseInt(timeZone) * 60) * 60 * 1000;
  const time =
    new Date().getTime() +
    (new Date().getTimezoneOffset() + parseInt(timeZone) * 60) * 60 * 1000;
  const now = new Date(timeStampTmp);
  now.setHours(0, 0, 0, 0);
  const lastTimeStampe = now.getTime() + 86400000;
  const downTimeStamp = lastTimeStampe - time;
  return downTimeStamp;
}
// 获取年月日
export function getDatefromTimeStampe(timeStamp) {
  // 秒时间戳转化为日期
  const timeStampTmp = getAnyZoneTimeStamp(Number(timeStamp) * 1000);
  const dateObj = new Date(timeStampTmp);
  const year = dateObj.getFullYear();
  const month = dateObj.getMonth();
  const date = dateObj.getDate();
  const hour = dateObj.getHours();
  const monthDays = new Date(year, month + 1, 0).getDate();
  const month1 = (month + 1).toString().padStart(2, "0");
  const date1 = date.toString().padStart(2, "0");
  const startDate = `${year}-${month1}-01`;
  const curDate = `${year}-${month1}-${date1}`;
  const endDate = `${year}-${month1}-${monthDays}`;
  // 倒计时时间戳
  const downTimeStamp = timeStampTmp + 86400000;
  return {
    year,
    month,
    date,
    hour,
    monthDays,
    downTimeStamp,
    startDate,
    curDate,
    endDate,
  };
}
// 获取当天最后时间戳
export function getDateLastTimeStampe() {
  // const timeStampTmp = new Date().getTime();
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const firstTimeStampe = now.getTime();
  const lastTimeStampe = firstTimeStampe + 86400000;
  // const firstTimeStampe = timeStampTmp - (timeStampTmp % 86400000);
  // const lastTimeStampe = timeStampTmp - (timeStampTmp % 86400000) + 86400000;
  console.log(firstTimeStampe, lastTimeStampe);
  return {
    firstTimeStampe,
    lastTimeStampe,
  };
}

// 获取应用当前结束的时间戳  用于当天倒计时
export function getAppDateLastTimeStampe() {
  // const timeStampTmp = new Date().getTime();
  let timeZone = Store.getters?.getPacketConfig?.appConfig?.timeZone || null;
  if (timeZone === undefined || timeZone === null) {
    timeZone = -4;
  }
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const timezoneOffset = timeZone * 60; // 将时区转换为分钟
  const timezoneDifference = now.getTimezoneOffset() - timezoneOffset; // 当前时区与目标时区的差异（分钟）
  const endOfDay = new Date(now.getTime() + timezoneDifference * 60 * 1000); // 当前时间加上时区差异
  endOfDay.setHours(24); // 设置为次日开始时间
  return endOfDay.getTime() + 86400000;
}

// 获取YYYY-MM-DD HH:MM:SS格式转换为MM-DD HH:MM
export function getDateBySubstringTime(dateStr) {
  if (!dateStr) return dateStr;
  // 截取月日部分（第5-10字符 "MM-DD"）
  const monthDay = dateStr.substring(5, 10);
  // 截取时分部分（第11-16字符 "HH:MM"）
  const hourMinute = dateStr.substring(11, 16);
  // 拼接成 "MM-DD HH:MM"
  return `${monthDay} ${hourMinute}`;
}
